import { render, staticRenderFns } from "./ResponsiveImageRatio.vue?vue&type=template&id=2409855c&"
import script from "./ResponsiveImageRatio.ts?vue&type=script&lang=ts&"
export * from "./ResponsiveImageRatio.ts?vue&type=script&lang=ts&"
import style0 from "./ResponsiveImageRatio.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports